import { useTranslation } from "react-i18next";

/**
 * A line for the one reader who can act on it.
 *
 * The Finnish catalogue was written by whoever added each entry, none of whom
 * speaks Finnish. Two kinds of fault in it can be caught mechanically and are
 * — a stray letter Finnish does not use, and an entry identical to the Polish
 * one, both being what pasting into the wrong block looks like. The kind that
 * cannot is a sentence that is grammatical, correctly formatted, carries the
 * right placeholders and simply reads wrong. No test on either side will find
 * that one.
 *
 * SO IT IS SAID TO THE PERSON WHO CAN. Somebody reading the English or the
 * Polish cannot judge the Finnish and does not need to hear about it; somebody
 * who chose Finnish is the only reader who can tell, and the only one worth
 * asking. The alternative is a known defect kept quiet on the grounds that
 * nobody has complained.
 *
 * It comes off the day a Finnish speaker has been through the catalogue. A
 * notice that needs removing later is a small debt and a fair one: the
 * alternative is not knowing.
 */
export default function UncheckedLanguage() {
  const { t, i18n } = useTranslation();
  if (i18n.resolvedLanguage !== "fi") return null;
  return (
    <div className="border-b border-amber-200 bg-amber-50 dark:border-amber-900 dark:bg-amber-950/40">
      <p
        lang="fi"
        className="mx-auto max-w-6xl px-4 py-1.5 text-xs text-amber-900 dark:text-amber-200"
      >
        {t("lang.uncheckedFi")}
      </p>
    </div>
  );
}
